import React from "react";
import { ReactComponent as Logo } from '../assets/logoblanco.svg';
import { FaFacebook, FaInstagram, FaWhatsapp, FaLinkedin } from "react-icons/fa";

const Footer = () => {
	const redes = [
		{ icon: FaWhatsapp, url: "https://api.whatsapp.com/send/?phone=%2B522222008962&text&type=phone_number&app_absent=0" },
		{ icon: FaFacebook, url: "https://www.facebook.com/profile.php?id=100076158990580#" },
		{ icon: FaInstagram, url: "https://www.instagram.com/loginem.1510/" },
		{ icon: FaLinkedin, url: "https://www.linkedin.com/in/loginem-logistica-integral-empresarial-14b106214/" },
	  ];

	return (
		<footer className="h-fit w-full grid grid-cols-1 p-4 bg-sky-800 shadow text-white">
			<div className="grid grid-cols-3">
				<div className="w-full flex justify-center items-center">
					<Logo className="w-44"/>
				</div>
				<div className="grid place-items-center gap-2">
					<h2> CONTACTO </h2>
					<p> +52 2222008962 </p>
					<p> loginem.1510@gmail.com </p>
				</div>
				<div className="grid place-items-center gap-2">
					<h2> DIRECCIÓN </h2>
					<p>
						{" "}
						Calle. 51 Poniente No. 110, Col. Prados Agua Azul, C.P. 72430, México, Puebla.{" "}
					</p>
				</div>
			</div>
			<div className="flex flex-row justify-center gap-8 py-8">
				{redes.map((red, index) => {
					const Icon = red.icon;
					return (
						<a
							key={index}
							href={red.url}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={red.name}
							className="text-white text-2xl hover:text-yellow-300 transition-colors"
						>
							<Icon />
						</a>
					);
				})}
			</div>
		</footer>
	);
};

export default Footer;
